import React from 'react';
import { PlayIcon } from 'lucide-react';
interface MediaPlaceholderProps {
  label?: string;
}
export function MediaPlaceholder({
  label = 'WALKTHROUGH — COMING SOON'
}: MediaPlaceholderProps) {
  const cleanLabel = label.replace(/^▶\s*/, '');
  return <div role="img" aria-label={`Media placeholder: ${cleanLabel}`} className="group/media relative flex aspect-video w-full flex-col items-center justify-center gap-4 overflow-hidden rounded-xl border border-dashed border-white/20 bg-black/40 px-5 text-center" data-id="element-48" data-mp="18k33jtrieu3y">
      <span className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_70%_at_50%_45%,rgba(16,185,129,0.12),transparent_70%)]" data-id="element-49" data-mp="ksnz9vg6a2q2" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#10b981]/40 bg-[#10b981]/10 text-[#10b981] transition-transform duration-200 group-hover/media:scale-105" data-id="element-50" data-mp="uqbvyqxc9kav">
        <PlayIcon className="h-5 w-5 translate-x-[1px] fill-[#10b981]" aria-hidden="true" data-id="element-51" data-mp="2658ucrfexluw" />
      </span>
      <span className="relative font-mono text-[11px] uppercase tracking-[0.22em] text-white/70" data-id="element-52" data-mp="i8z4bv4vofo8">
        {cleanLabel}
      </span>
    </div>;
}